<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->
<div class="row justify-content-start">
  <div id="overlay" (click)="closeNav()">
  </div>
</div>
<div id="candidate-slider">
  <div *ngIf="showCandidate">
    <app-person-search-candidate-slider [data]="currentCandidate" [tabType]="tabType" [currentIndex]="0">
      <div addToTalentPool class="d-inline-flex">
        <div>

          <p class="add-to-talentpool p-1 text-webbtree-green pointer mr-2 text-nowrap" (click)="extractCandidate(currentCandidate)">
              <i class="fas fa-user-plus mr-1"></i>
              Add to Talent pool
          </p>
        </div>

      </div>
    </app-person-search-candidate-slider>
  </div>
</div>

<div class="col d-flex"
style="border: 1px dotted #206c79; background-color: #ffffff;padding: 26px 32px 24px 27px;margin-top: 0px;"
*ngIf="isExtensioninstalled != true && searchCalled == false">
  <div class="col-md-2 mr-6" style="overflow:hidden">
    <img src="../assets/group.png" style="width: 206px;
    height: 161px;">
  </div>
  <div class="col">
    <p class="f-16">
      Webbtree's Chrome Extension helps you source, enrich and nurture talent from across the web
    </p>
    <p class="f-14 d-flex " style="color: #777777;"><span><i class="fas fa-circle mr-3 f-10"
          style="color: #777777;"></i></span>Grab candidates you discover on LinkedIn, GitHub, Stack Overflow,
      Kaggle,
      Naukri, Career Builder and build talent pools.</p>
    <p class="f-14 d-flex" style="color: #777777;"> <span><i class="fas fa-circle mr-3 f-10"
          style="color: #777777;"></i></span> Find contact number, email addresses and social profiles of candidate
      you discover. </p>

    <div class="pointer">
      <button data-testid="auto-searchtoolbox-v3-button-1" class="btn-trms-small" (click)="routeURL()">
        Add chrome extension</button>
    </div>
  </div>
</div>

<div *ngIf="searchCalled == true && bulkGrabbingDonePreviously == false" class="mt-4">
  <div class="d-flex mb-2"
  style="background-color: #ffffff;padding: 26px 32px 24px 27px;margin-top: 15px;">
  <div class="col-md-2">
    <img src="../../../assets/images/premium-user-error.png" style="width: 152px;">
  </div>
  <div class="col-md-8">
    <p class="f-14" style="color: #484b59; font-weight: 600; line-height: 0px;">Extract single or multiple profiles!</p>
    <p class="f-12" style="color: #484b59; font-weight: 500; line-height: 14px;">Extract to talentpools and export to CSV in bulk - Detailed work experience, years of experience, education, skills and more</p>
    <div class="enabled-button" style="width: 160px;
    height: 36px;
    margin-left: 0px;
    margin-top: -6px;">

      <span  (click)="bulkSelectAndExtract()" class="pointer">Extract All Profiles</span>
    </div>
  </div>
  <div class="col-md-2 d-flex" style="justify-content: flex-end;">
    <p class="text-webbtree-green pointer" (click)="skipExtract()">Skip</p>
  </div>
  </div>
</div>
<div class="row">
  <div class="col pt-2" *ngIf="!showSearchResult">
    <ul class="nav nav-pills wccard blue-border">
      <li class="nav-item mr-3" (click)="updateTabToShow('bbuilder')">
        <a data-testid="auto-searchtoolbox-v3-a-1" class="nav-link active" id="pills-bbuilder-tab" data-bs-toggle="pill" href="#pills-bbuilder" role="tab"
          [ngClass]="{'active':tabActive == 'bbuilder'}" aria-controls="pills-bbuilder" aria-selected="true"> <i
            class="far fa-search mx-1"
            [ngClass]="{'font-weight-600': tabActive == 'bbuilder','active':tabActive == 'bbuilder'}"></i> Boolean
          Builder</a>
      </li>
      <li class="nav-item  mr-3" (click)="updateTabToShow('pboolean')">
        <a data-testid="auto-searchtoolbox-v3-a-2" class="nav-link" id="pills-pboolean-tab" data-bs-toggle="pill" href="#pills-pboolean" role="tab"
          [ngClass]="{'active':tabActive == 'pboolean'}" aria-controls="pills-pboolean" aria-selected="false"> <i
            class="fa-paste mx-1"
            [ngClass]="{'fas': tabActive == 'pboolean','far': tabActive != 'pboolean','active':tabActive == 'pboolean'}"></i>
          Paste Boolean</a>
      </li>
      <!-- <li class="nav-item  mr-3" (click)="updateTabToShow('jdmode')" >
        <a data-testid="auto-searchtoolbox-v3-a-3" class="nav-link" id="pills-jdmode-tab" data-bs-toggle="pill" href="#pills-jdmode" role="tab"
          [ngClass]="{'active':tabActive == 'jdmode'}" aria-controls="pills-jdmode" aria-selected="false"> <i
            class="fa-file mx-1"
            [ngClass]="{'fas': tabActive == 'jdmode','far': tabActive != 'jdmode','active':tabActive == 'jdmode'}"></i>
          JD Mode</a>
      </li> -->
    </ul>


    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade" id="pills-bbuilder" role="tabpanel"
        [ngClass]="{'show active': tabActive == 'bbuilder' || jdMode == true}" aria-labelledby="pills-bbuilder-tab">
        <div class="row ml-0">
          <!-- <div class="col-md-12"> -->
          <div class="col-md-6 mt-1">
            <div class="row mb-1">
              <div class="col wccard pt-3">
                <div class="text-bluex font-weight-600 mb-2 pointer" (click)="updateTabToShow('jdmode','back')"
                  *ngIf="jdMode == true">
                  Back to JD Mode
                </div>
                <div class="d-flex justify-content-between mb-1">
                  <span class="font-weight-600">
                    Boolean Builder
                  </span>

                  <span class="text-bluex pointer" (click)="resetAllFields()" *ngIf="jobtitles.length || mandatoryskills.length  || preferredskills.length || locations.length || companies.length || synonyms.length
                   || excludekeywords.length || recommendedjobtitle.length || recommendedskills.length">
                    <i class="fas fa-redo mr-1"></i> Reset
                  </span>
                </div>
                <p class="text-9696 f-12">
                  X-ray search on
                  <span style="color:#4285F4">G</span>
                  <span style="color:#DB4437">o</span>
                  <span style="color:#F4B400">o</span>
                  <span style="color:#4285F4">g</span>
                  <span style="color:#0F9D58">l</span>
                  <span style="color:#DB4437">e</span> to find relevant candidate.
                </p>

                <div class="mb-3">
                  <div class="justify-content-between d-flex mb-1 mb-1">
                    <span>
                      Job Title
                    </span>

                    <span class="d-flex align-items-center">
                      <label class="wc-checkbox mr-1 mb-0">
                        <input data-testid="auto-searchtoolbox-v3-input-1" type="checkbox" id="mycheck" name="mycheck" [(ngModel)]="isCurrentJobTitle">
                        <i class="fas fa-check"></i>
                      </label>
                      <label class="mb-0" for="mycheck">
                        <span class="f-14">Current Job Title</span>
                      </label>
                    </span>

                  </div>

                  <div class="position-relative">
                    <div class="position-relative">
                      <p-autoComplete class="d-flex flex-column" [(ngModel)]="jobtitles" [suggestions]="filteredJobTitleOptions"
                        [style]="{'width':'100%'}" #jobtitle_complete
                        (keyup.enter)="addDataToRequest($event.target.value , 'job titles','enter');$event.target.value = '';jobtitle_complete.hide()"
                        placeholder="Eg. Software Engineer, HR Manager, UX Designer etc"
                        (onSelect)="addDataToRequest($event, 'job titles');jobtitle_complete.hide()"
                        (onUnselect)="removeSelectedChip($event,'job titles')"
                        (completeMethod)="searchAutoCompletedData($event , 'job titles')" [multiple]="true">
                      </p-autoComplete>
                    </div>
                  </div>

                  <div class="suggestion-strip" *ngIf="recommendedjobtitle?.length == 0">
                    - Enter a Job Title for suggestions -
                  </div>

                  <div class="customChip mr-1 mt-1 "
                    *ngFor="let jobtitle of recommendedjobtitle?.slice(0,5) ;let i = index"
                    (click)="addDataToRequest(jobtitle , 'job titles','recommended_chips');" title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>

                </div>

                <div class="mb-3 mt-3">
                  <div class="justify-content-between d-flex mb-1">
                    <span>
                      Preferred Skills
                    </span>
                  </div>

                  <div class="position-relative">
                    <div class="position-relative">
                      <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredMandatorySkillsOptions"
                        [style]="{'width':'100%'}" #pskills
                        (keyup.enter)="addDataToRequest($event.target.value , 'preferred skills','enter');$event.target.value = '';pskills.hide()"
                        placeholder="Keywords Considered As: Java OR Management OR Communication"
                        (onSelect)="addDataToRequest($event, 'preferred skills');pskills.hide()"
                        (onUnselect)="removeSelectedChip($event,'preferred skills')"
                        (completeMethod)="searchAutoCompletedData($event , 'skills')" [multiple]="true">
                      </p-autoComplete>
                    </div>
                  </div>

                  <div class="suggestion-strip" *ngIf="recommendedskills?.length == 0">
                    - Enter a Skill for suggestions -
                  </div>

                  <div class="customChip mr-1 mt-1 " *ngFor="let skills of recommendedskills?.slice(0,5) ;let i = index"
                    (click)="addDataToRequest(skills , 'preferred skills','recommended_chips');" title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>

                </div>


              </div>
            </div>
            <div class="row mb-2px" *ngIf="additionfields">
              <div class="col wccard">

                <section *ngIf="additionfields">
                  <div class="mb-3 mt-3">
                    <div class="justify-content-between d-flex mb-1 mb-1">
                      <span>
                        Mandatory Skills
                      </span>
                    </div>

                    <div class="position-relative">
                      <div class="position-relative">
                        <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredMandatorySkillsOptions"
                          [style]="{'width':'100%'}" #mskills
                          (keyup.enter)="addDataToRequest($event.target.value , 'mandatory skills','enter');$event.target.value = '';mskills.hide()"
                          placeholder="Keywords Considered As: Java AND Management AND Communication"
                          (onSelect)="addDataToRequest($event, 'mandatory skills');mskills.hide()"
                          (onUnselect)="removeSelectedChip($event,'mandatory skills')"
                          (completeMethod)="searchAutoCompletedData($event , 'skills')" [multiple]="true">
                        </p-autoComplete>
                      </div>
                    </div>

                    <div class="suggestion-strip" *ngIf="recommendedskills?.length == 0">
                      - Enter a Skill for suggestions -
                    </div>

                    <div class="customChip mr-1 mt-1 "
                      *ngFor="let skills of recommendedskills?.slice(0,5) ;let i = index"
                      (click)="addDataToRequest(skills , 'mandatory skills','recommended_chips');" title="{{skills}}">
                      <div class="chipname" name="skills">{{skills}}</div>
                      <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                    </div>

                  </div>

                  <div class="mb-3">
                    <div class="justify-content-between d-flex mb-1">
                      <span>
                        Location
                      </span>
                    </div>

                    <div class="position-relative">
                      <p-autoComplete [(ngModel)]="locations" [suggestions]="filteredLocationsOptions"
                        [style]="{'width':'100%'}" #locations_auto
                        (keyup.enter)="addDataToRequest($event.target.value , 'locations','enter');$event.target.value = '';locations_auto.hide()"
                        placeholder="Eg. Mumbai, London, New York, Tokyo etc"
                        (onSelect)="addDataToRequest($event, 'locations');locations_auto.hide()"
                        (onUnselect)="removeSelectedChip($event,'locations')"
                        (completeMethod)="searchAutoCompletedData($event , 'locations')" [multiple]="true">
                      </p-autoComplete>
                    </div>
                  </div>

                  <div class="mb-3">
                    <div class="justify-content-between d-flex mb-1">
                      <span>
                        Company
                      </span>

                      <span class="d-flex align-items-center mb-1">
                        <label class="wc-checkbox mr-1 mb-0">
                          <input data-testid="auto-searchtoolbox-v3-input-2" type="checkbox" id="mycheck" name="mycheck" [(ngModel)]="isCurrentCompany">
                          <i class="fas fa-check"></i>
                        </label>
                        <label class="mb-0" for="mycheck">
                          <span class="f-14">Current Company</span>
                        </label>
                      </span>

                    </div>

                    <div class="position-relative">
                      <p-autoComplete [(ngModel)]="companies" [suggestions]="filteredCompaniesOptions"
                        [style]="{'width':'100%'}" #companies_auto
                        placeholder="Eg, Swiggy, Amazon, Google, Cognizant etc" field="company_name"
                        (keyup.enter)="addDataToRequest($event.target.value , 'companies','enter');$event.target.value = '';companies_auto.hide()"
                        (onSelect)="addDataToRequest($event, 'companies');companies_auto.hide()"
                        (onUnselect)="removeSelectedChip($event,'companies')"
                        (completeMethod)="searchAutoCompletedData($event , 'companies')" [multiple]="true">
                        <ng-template let-companies pTemplate="item">
                          <div class="country-item">
                            <div class="font-weight-500 text-capitalize">{{companies.company_name}}</div>
                            <p class="text-capitalize font-weight-400 greybg f-12">{{companies.industry_name}}</p>
                          </div>
                        </ng-template>
                      </p-autoComplete>
                    </div>

                  </div>
                  <div class="mb-3">
                    <span class="d-flex align-items-center">
                      <label class="wc-checkbox mr-1 mb-0">
                        <input data-testid="auto-searchtoolbox-v3-input-3" type="checkbox" id="opencheck" name="opencheck" [(ngModel)]="isOpentoWork">
                        <i class="fas fa-check"></i>
                      </label>
                      <label class="mb-0" for="opencheck">
                        <span class="f-14">Open to work</span>
                      </label>
                    </span>

                  </div>

                  <div class="mb-3">
                    <div class="justify-content-between d-flex mb-1">
                      <span>
                        Exclude Keywords
                      </span>
                    </div>

                    <div class="position-relative">
                      <p-autoComplete [(ngModel)]="excludekeywords" [style]="{'width':'100%'}" #excludekeywords_auto
                        (keyup.enter)="addDataToRequest($event.target.value , 'excludekeywords','enter');$event.target.value = '';excludekeywords_auto.hide()"
                        placeholder="Add keywords that you want to exclude from your search"
                        (onSelect)="addDataToRequest($event, 'excludekeywords');excludekeywords_auto.hide()"
                        (onUnselect)="removeSelectedChip($event,'excludekeywords')" [multiple]="true"></p-autoComplete>
                    </div>
                  </div>


                </section>


              </div>
            </div>
            <div class="row mb-2px" *ngIf="additionfields">
              <div class="col wccard pt-3">
                <div class="mb-3">
                  <div class="">
                    <p class="font-weight-500 mb-2">
                      Expand your search
                    </p>
                    <p class="mb-3 f-14 line-height-1 text-9696">
                      Add pre-made lists to expand your search using synonyms by Google's programmable search (CSE)
                      inbuilt with Webbtree <i class="fas fa-external-link-alt text-webbtree-green ml-2 pointer"
                        (click)="route2link()"></i>
                    </p>
                  </div>

                  <div class="row">

                    <div class="col-md-6 mb-2" *ngFor="let mapping of mappings; let i = index;"
                      title="{{mapping.mappingdescription}}">
                      <span class="d-flex align-items-center">
                        <label class="wc-checkbox mr-1 mb-0">
                          <input data-testid="auto-searchtoolbox-v3-input-4" type="checkbox" id={{mapping?.mappingcode}} name={{mapping?.mappingcode}}
                            (change)="selectMapping($event,mapping)"
                            [checked]="synonyms?.includes(mapping?.mappingcode)">
                          <i class="fas fa-check"></i>
                        </label>
                        <label class="mb-0" for={{mapping?.mappingcode}} [ngbTooltip]="mapping_tooltip"
                          placement="right" tooltipClass="my-custom-class">
                          <span class="f-14 text-capitalize">{{mapping.mappingdescription}}</span>
                        </label>
                      </span>
                      <ng-template #mapping_tooltip>
                        <p class="f-12 mb-0 font-weight-500"> Keywords Included: </p>
                        <span class="f-12"> {{mapping.mappingvalues}} </span>
                      </ng-template>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col wccard py-3">
                <p *ngIf="fieldsRequired" class="text-danger">
                  Enter atleast one keyword to generate results
                </p>
                <div class="d-flex justify-content-between align-items-center">
                  <span class="text-bluex font-weight-500 pointer" (click)="showAdditionalFields(true)"
                    *ngIf="!additionfields">
                    + Show additional fields
                  </span>

                  <span class="text-bluex font-weight-500 pointer" (click)="showAdditionalFields(false)"
                    *ngIf="additionfields">
                    - Hide additional fields
                  </span>

                  <span>
                    <button data-testid="auto-searchtoolbox-v3-button-2" class="btn-trms-medium m-auto" (click)="generateBooleanAndSearch('LinkedIn')">Generate
                      Boolean &
                      Search</button>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-1 ">
            <div class="wccard mb-1 p-3">
              <div class="font-weight-600 mb-1"> Try with an example:</div>
              <p class="f-12 text-9696">Create your boolean by selecting any of the the examples below</p>

              <div class="try-example" (click)="searchExample('1')">
                <span class="text-bluex font-weight-500">
                  Candidates with current job title Software Engineer in San Francisco
                </span>
              </div>
              <div class="try-example" (click)="searchExample('2')">
                <span class="text-bluex font-weight-500">
                  Freelance UI/UX Designers based in London
                </span>
              </div>
              <div class="try-example" (click)="searchExample('3')">
                <span class="text-bluex font-weight-500">
                  Senior electrical engineers in New York | <span style="color: #ffc400;">
                    Exclude Keyword
                  </span> : “Junior”
                </span>
              </div>
            </div>

            <div class="wccard mb-1 p-3">
              <div class="d-flex justify-content-between">
                <span class="font-weight-600">
                  Search History
                </span>

                <span class="text-webbtree-green pointer" (click)="openHistoryModal()"
                  *ngIf="searchToolboxHistory?.length > 0">
                  All History
                </span>
              </div>
              <hr class="mt-3 mb-0" style="border-top: 1px solid rgba(0, 0, 0, 0.1);">
              <div *ngFor="let history of searchToolboxHistory?.slice(0,5); index as i" class="row mx-0 mb-3px py-3 "
                style="border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
                <div class="col bb-3px">
                  <div class="row">
                    <div class="col d-flex justify-content-between mb-0 px-0">
                      <a data-testid="auto-searchtoolbox-v3-a-4" class="gray-text pointer collapsed font-weight-normal d-flex justify-content-between w-100"
                        data-bs-toggle="collapse" href="#collapseExample{{i}}" role="button" aria-expanded="false"
                        aria-controls="collapseExample" [ngClass]="{'showdhidearrow':!history.booleanquery}">
                        <div class="">
                          <p class="f-14 font-weight-500 text-black mb-0 text-capitalize">
                            {{getHistoryHeadline(history)}}</p>
                        </div>
                        <div *ngIf="history.booleanquery">
                          <div class="col d-flex justify-content-between">
                            <p class="f-10 text-9696 mr-2 mt-1 mb-0"  style="width: 105px;">{{formatDate(history?.updatedon)}}</p>
                            <i class="far fa-repeat-alt f-16 text-bluex" (click)="repeatSearch(history)"></i>
                          </div>
                        </div>
                        <div *ngIf="!history.booleanquery">
                          <div class="col d-flex justify-content-between">
                            <p class="f-10 text-9696 mr-2 mt-1 mb-0"  style="width: 105px;">{{formatDate(history?.updatedon)}}</p>
                            <i class="far fa-repeat-alt f-16 text-bluex mr-2" (click)="repeatSearch(history)"></i>
                            <i class="far fa-chevron-down f-16 text-bluex"></i>
                            <i class="far fa-chevron-up f-16 text-bluex"></i>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="collapse w-100 mt-3px mt-3" id="collapseExample{{i}}" *ngIf="!history.booleanquery">
                  <div class="row">
                    <div class="col-md-12" *ngIf="history?.booleanquery">
                      <p class="mb-0">
                        {{history?.booleanquery}}
                      </p>
                    </div>
                    <div class="col-md-6" *ngIf="history?.jobtitles">
                      <p class="text-9696 mb-1"> Job Title </p>
                      <p class="mb-0">
                        {{history?.jobtitles}}
                      </p>
                    </div>
                    <div class="col-md-6" *ngIf="history?.mandatoryskills">
                      <p class="text-9696 mb-1"> Mandatory Skills </p>
                      <p class="mb-0">
                        {{history?.mandatoryskills}}
                      </p>
                    </div>
                    <div class="col-md-6" *ngIf="history?.preferredskills">
                      <p class="text-9696 mb-1"> Preferred Skills </p>
                      <p class="mb-0">
                        {{history?.preferredskills}}
                      </p>
                    </div>
                    <div class="col-md-6" *ngIf="history?.locations">
                      <p class="text-9696 mb-1"> Location </p>
                      <p class="mb-0">
                        {{history?.locations}}
                      </p>
                    </div>
                  </div>
                  <!-- <hr class="my-2"> -->
                </div>
              </div>
              <div *ngIf="searchToolboxHistory?.length == 0">
                <div class="col text-center">
                  <div class="row mt-3">
                    <div class="col-6 py-6 m-auto">
                      <img src="../../../assets/images/search-engine-1.png" class="img-fluid" alt="" srcset="">
                    </div>
                  </div>
                  <div class="pb-4">
                    <p class="font-weight-500 f-14 py-3 text-9696">No searches performed so far</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <!-- </div> -->
        </div>
      </div>

      <div class="tab-pane fade" id="pills-pboolean" role="tabpanel" aria-labelledby="pills-pboolean-tab"
        [ngClass]="{'show active': tabActive == 'pboolean'}">
        <div class="row mr-0">
          <div class="col mt-1 ">
            <div class="wccard p-3">
            <div class="row mb-4 bb1px">
              <div class="col">
                <p class="font-weight-600 mb-1">
                  Boolean Search
                </p>
                <p class="f-12 text-9696">
                  Already have a boolean string? Paste here to use additional features and perform search across social
                  platforms
                </p>
                <div class="mb-3">
                  <div class="position-relative">
                    <input data-testid="auto-searchtoolbox-v3-input-5" type="text" placeholder="Paste your boolean query here" class="wc-form-control nobg"
                      [(ngModel)]="booleanquery">
                  </div>

                </div>

              </div>
              <hr>
            </div>
            <div class="row mb-4 bb1px">
              <div class="col">
                <div class="mb-3">
                  <div class="">
                    <p class="font-weight-500 mb-2">
                      Add Synonyms
                    </p>
                    <p class="mb-2 f-14 text-9696">
                      Use our most common lists to expand your search by adding synonyms by Google
                    </p>
                  </div>

                  <div class="row">

                    <div class="col-md-6 mb-2" *ngFor="let mapping of mappings; let i = index;"
                      title="{{mapping.mappingdescription}}">
                      <span class="d-flex align-items-center">
                        <label class="wc-checkbox mr-1 mb-0">
                          <input data-testid="auto-searchtoolbox-v3-input-6" type="checkbox" id={{mapping?.mappingcode}} name={{mapping?.mappingcode}}
                            (change)="selectMapping($event,mapping)"
                            [checked]="boolean_synonyms?.includes(mapping?.mappingcode)">
                          <i class="fas fa-check"></i>
                        </label>
                        <label class="mb-0" for={{mapping?.mappingcode}} [ngbTooltip]="mapping_tooltip"
                          placement="right" tooltipClass="my-custom-class">
                          <span class="f-14 text-capitalize">{{mapping.mappingdescription}}</span>
                        </label>
                      </span>
                      <ng-template #mapping_tooltip>
                        <p class="f-12 mb-0 font-weight-500"> Keywords Included: </p>
                        <span class="f-12"> {{mapping.mappingvalues}} </span>
                      </ng-template>
                    </div>

                  </div>
                </div>

              </div>

            </div>
            <p *ngIf="Boolean_fieldsRequired" class="text-danger">
              Please enter a boolean query to search
            </p>
            <div class="text-right mb-4">
              <button data-testid="auto-searchtoolbox-v3-button-3" class="btn-trms-small m-auto" (click)="searchBooleanQuery('LinkedIn', 'updated')">Search</button>
            </div>
            </div>
          </div>
          <div class="col mt-1 wccard error-img text-center"
            style="display: flex;align-items: center;justify-content: center;">
            <div class=" p-3">


            <div>
              <img src="assets/images/moving-forward-two-color.png" class="img-fluid">
              <p class="">Build Boolean queries without learning to use operators</p>
            </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-pane fade" id="pills-jdmode" role="tabpanel" aria-labelledby="pills-jdmode-tab"
        [ngClass]="{'show active': tabActive != 'bbuilder' && tabActive != 'pboolean' && jdMode != true}">
        <div class="row mr-0">
          <div class="col mt-1">
            <div class="wccard p-3 ">
            <p class="font-weight-600 mb-3">
              Search Using JD
            </p>
            <!-- <p class="f-12 text-9696 mb-5">
              Use a Job description to create your boolean and perform search across multiple social platforms.
            </p> -->
            <div class="mb-3">
              <div class="">

                <div class="row" *ngIf="!enteredJobDescription || enteredJobDescription.length == 0">
                  <div class="col mb-2">
                    <label for="jd-upload" class="f-14 font-weight-500"> Upload a JD </label>
                    <div class="ats-upload-btn">
                      <div *ngIf="!isUploadedFileCorrect" class="col text-center p-6">
                        <div class="col">
                          <p class="font-weight-600 text-bluex mb-0">
                            Drag and drop JD file here
                          </p>
                        </div>
                      </div>

                      <input data-testid="auto-searchtoolbox-v3-input-7" *ngIf="!isUploadedFileCorrect" type="file" #document (change)="uploadFile($event)"
                        accept=".doc,.docx,.txt,.pdf, .dot,.rtf,.odt,.htm,.html">

                      <button data-testid="auto-searchtoolbox-v3-button-4" *ngIf="isUploadedFileCorrect" (click)="resetFormFields()"
                        class="btn-trms-white m-auto">
                        Remove file
                      </button>

                    </div>
                  </div>
                </div>

                <div *ngIf="!enteredJobDescription || enteredJobDescription.length == 0" class="align-items-center">
                  <p *ngIf="isUploadedFileCorrect && !specialCharaterError && !incorrectFileFormat"
                    [ngClass]="['text-left','my-1']">
                    <span class="font-weight-600">Uploaded file:</span> {{ uploadedFilename }}
                  </p>
                  <p *ngIf="specialCharaterError" [ngClass]="['text-left','my-1','text-danger']">
                    Filename should not contain any special characters
                  </p>
                  <p *ngIf="incorrectFileFormat" [ngClass]="['text-left','my-1','text-danger']">
                    File type should be .doc or .pdf or .docx or .txt
                  </p>
                  <p *ngIf="fileSizeLimitExceeded" [ngClass]="['text-left','my-1','text-danger']">
                    File size cannot exceed 5 MB
                  </p>
                </div>



                <div class="position-relative">
                  <h5 class="center-position f-16" *ngIf="!enteredJobDescription || enteredJobDescription.length == 0">
                    OR</h5>
                  <hr>

                </div>
                <div class="row">
                  <div class="col">
                    <p class="mb-2 f-14 font-weight-500">
                      Paste Job Description
                    </p>
                    <div class="position-relative ">
                      <textarea data-testid="auto-searchtoolbox-v3-textarea-1" [disabled]="disableManualJDInput" type="text" placeholder="Enter the job description"
                        [(ngModel)]="enteredJobDescription" class="wc-textarea wc-form-control mb-2"
                        rows="6"></textarea>
                    </div>
                  </div>
                </div>

                <div class="align-items-center">
                  <p *ngIf="showJDNotAddedError" [ngClass]="['text-left','my-1','text-danger']">
                    *Please upload or enter job description
                  </p>
                </div>

              </div>

            </div>
            <p class="text-danger mb-2" *ngIf="jdParseError">
              No relevant keywords were found. Please retry with a different Job Description
            </p>
            <div class="text-right">
              <button data-testid="auto-searchtoolbox-v3-button-5" class="btn-trms-medium m-auto" (click)="addJobDescription()">Parse Keywords from JD</button>
            </div>
            </div>
          </div>
          <div class="col mt-1  wccard  error-img text-center"
            style="display: flex;align-items: center;justify-content: center;">
            <div class="p-3">
              <img src="assets/images/moving-forward-two-color.png" class="img-fluid">
              <p class="col-10 mx-auto line-height-1">Webbtree helps you build lists of candidates matching your search
                parameters helping you with the most sought after skill among Talent Sourcers which is boolean
                searching.
                Webbtree's search is more powerful than traditional search engine X-Ray methods and helps to overcome
                various social sites' search limitations along with additional advanced filters.</p>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

  <div class="col-md-12 pt-2" *ngIf="showSearchResult">
    <div class="text-bluex mb-2 pointer" (click)="backToBbuilder()">
      <i class="fas fa-arrow-left mr-2"> </i> Back to Boolean Builder
    </div>

    <div class="wccard p-3">
      <div class="row">
        <div class="col-md-12">
          <div class="justify-content-between d-flex mb-2">
            <span class="font-weight-500">
              Boolean String <i class="fas fa-info-circle text-9696 ml-1" [ngbTooltip]="Synonyms" placement="right"
                *ngIf="searchQuerySentToCSE" tooltipClass="my-custom-class"></i>
              <ng-template #Synonyms>
                <p class="f-12 mb-0 txt-prim"> Generated search query : </p>
                <span class="f-12 font-weight-600"> {{searchQuerySentToCSE}} </span>
              </ng-template>
            </span>

            <div class="text-bluex font-weight-500 pointer mx-2" (click)="openHistoryModal()">
              <i class="far fa-clock mr-1"></i> Search History
            </div>

          </div>
          <div class="mb-2 d-flex align-items-center justify-content-between" *ngIf="!editBooleanQuery">
            <span class="d-flex mr-3" style="width: 100%;">
              <span class="font-weight-500 bq-div pointer" [innerHTML]="booleanquery_to_display" style="width: 95%;" (click)="editBooleanQuery = true">
              </span>
              <div class="reveal-btn mb-0 d-flex" (click)="editBooleanQuery = true">
                <div class="m-auto d-flex">
                  Edit <i class="far fa-edit ml-2" style="margin-top: 1px;"> </i>
                </div>
              </div>
            </span>
            <span class="text-bluex pointer ml-auto mx-2 d-flex" (click)="copyBooleanQuery()"
              style="justify-content: center;text-align: center;margin: auto;">
              Copy
              <i class="far fa-copy ml-1 mt-3px"> </i>
            </span>
          </div>
          <div class="mb-2 d-flex align-items-center justify-content-between" *ngIf="editBooleanQuery">
            <span class="d-flex mr-3" style="width: 100%;">
              <textarea data-testid="auto-searchtoolbox-v3-textarea-2" type="text" placeholder="Paste your boolean query here" class="wc-form-control nobg boolean-input"
                style="width: 95%;
                overflow: hidden;
                height: auto;line-height: 1.3;resize: none;" [(ngModel)]="booleanquery"> </textarea>
              <div class="reveal-btn mb-0 d-flex" (click)="searchBooleanQuery('LinkedIn','updated');editBooleanQuery = false">
                <div class="m-auto d-flex">
                  Results <i class="far fa-rotate-right ml-2 mt-3px"></i>
                </div>
              </div>
            </span>
            <span class="text-bluex pointer ml-auto mx-2 d-flex" (click)="copyBooleanQuery()"
              style="justify-content: center;text-align: center;margin: auto;">
              Copy
              <i class="far fa-copy ml-1 mt-3px"> </i>
            </span>
          </div>

          <p class="f-12 text-9696 font-weight-500" *ngIf="synonyms.length > 0 && tabActive != 'pboolean'">
            <i class="fas fa-exclamation-circle mr-1" style="color: #ffc400;"></i> Synonyms to include pre-made Webbtree
            lists in your search: {{synonyms?.join(', ')}}
          </p>
          <p class="f-12 text-9696 font-weight-500" *ngIf="boolean_synonyms.length > 0 && tabActive == 'pboolean'">
            <i class="fas fa-exclamation-circle mr-1" style="color: #ffc400;"></i> Synonyms to include pre-made Webbtree
            lists in your search: {{boolean_synonyms?.join(', ')}}
          </p>
          <div class="d-flex justify-content-between mb-1">
            <span class="d-flex">
              <span class="font-weight-500 mt-1">
                X-Ray search across:
              </span>
              <div class="position-relative">
                <span class="selectdrop-down position-absolute tr0 text-webbtree-green"><i
                    class="far fa-chevron-down"></i> <i class="far fa-chevron-up"></i></span>

                <span class="dropdown ats-dropBtn mx-1 ml-2">
                  <button data-testid="auto-searchtoolbox-v3-button-6" class="ats-btn dropdown-toggle position-relative" type="button" id="dropdownMenuButton"
                    appDropdownToggle aria-haspopup="true" aria-expanded="false"
                    style="height: 25px;width: 100%; color: #2e93a1;">
                    {{platformselected}} <span class="position-absolute" style="right:0px"><i
                        class="fas fa-angle-down"></i></span>
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a data-testid="auto-searchtoolbox-v3-a-5" class="dropdown-item"
                      [ngClass]="{'p-category': x.platforname == 'General' || x.platforname == 'Technical' || x.platforname == 'Creative','p-none' : x.platforname == platformselected}"
                      *ngFor="let x of platformlist" (click)="SelectSearchPlatform(x.platforname,'refreshindex')"> <i
                        class="{{x?.classname}}"></i> {{x?.platforname}}</a>
                  </div>
                </span>
              </div>
            </span>
          </div>
          <p class="f-12 text-9696">
            Source for candidates through multiple social platforms using Google's programmable search (CSE) inbuilt
            with Webbtree
          </p>

          <div class="tab-pane fade active show" *ngIf="searchResults && searchResults.length > 0">
            <div class="d-flex mb-3" *ngFor="let x of searchResults; let j = index">
                <div class="col p-3 d-flex justify-content-between pr-0 align-items-center" style="border: solid 1px #ecf0f4;">


                <div class="d-flex px-0 pr-2 col-9">
                  <div class="canProfilePic mr-3">
                    <img *ngIf="(x.pagemap && x.pagemap.cse_thumbnail && x.pagemap.cse_thumbnail.length > 0)"
                      src="{{x.pagemap.cse_thumbnail[0].src}}" alt="None" class="img-search">
                    <i class="fas fa-user"
                      *ngIf="!(x.pagemap && x.pagemap.cse_thumbnail && x.pagemap.cse_thumbnail.length > 0)"></i>
                  </div>
                  <div>
                    <p class="mb-1 f-14"><a data-testid="auto-searchtoolbox-v3-a-6" href="{{x?.formattedUrl}}" target="_blank" (click)="candidateCT(x.formattedUrl)"
                        class="text-capitalize search-title text-webbtree-green"
                        [innerHtml]="x.htmlTitle">
                      </a></p>
                    <p class="line-height-1 mb-1"><span class="ml7px f-12 font-weight-500 text-484b59 line-height-1"
                        [innerHtml]="x.htmlSnippet"></span></p>
                    <p class="f-12 text-9696 mb-0">
                      {{x.locationname}}
                     <span *ngIf="x.jobtitle"> • {{x.jobtitle}}  </span>
                     <span *ngIf="x.companyname"> • {{x.companyname}}  </span>
                  </div>
                </div>
                <div class="px-0 loader-div mx-5">
                  <!-- <div class="reveal-btn mx-auto candidate-reveal py-2 px-6" [ngClass]="{'disabled-reveal-btn' : candidatetoBeGrabbed?.length}" *ngIf="platformselected != 'LinkedIn'" style="width: 200px">
                    <span>
                       <i class="far fa-envelope mr-1 font-weight-normal f-14" *ngIf="platformselected != 'LinkedIn'"></i> Explore Connect
                    </span>
                  </div> -->
                  <!-- <div class="reveal-cand mx-auto candidate-reveal py-2 px-6 pointer" (click)="openSlider(x)" [ngClass]="{'disabled-reveal-btn' : candidatetoBeGrabbed?.length}" *ngIf="platformselected == 'LinkedIn'">
                    <span class="">Reveal Contact</span>
                  </div> -->
                </div>
              </div>
            </div>

            <div class="d-flex mb-1 justify-content-center ">
              <ngb-pagination *ngIf="platformselected == 'LinkedIn'" [collectionSize]="getResultForLinkedin.length + 10" [maxSize]="10" [pageSize]="30" [rotate]="true"
                (pageChange)="setPage($event)" [(page)]="pageNumber">
                <ng-template ngbPaginationPrevious>Previous</ng-template>
                <ng-template ngbPaginationNext>Next</ng-template>
              </ngb-pagination>

              <ngb-pagination *ngIf="platformselected != 'LinkedIn'" [collectionSize]="totalSearchResultsCount" [maxSize]="10" [pageSize]="10" [rotate]="true"
                (pageChange)="setPage($event)" [(page)]="pageNumber">
                <ng-template ngbPaginationPrevious>Previous</ng-template>
                <ng-template ngbPaginationNext>Next</ng-template>
              </ngb-pagination>
            </div>

          </div>
          <div *ngIf="searchResults && searchResults.length == 0 && !isLoading">
            <div class="col text-center">
              <div class="row mt-3">
                <div class="col-6 py-6 m-auto">
                  <img src="../../../assets/images/Dog walking_Two Color.png" class="img-fluid" alt="" srcset="">
                </div>
              </div>
              <div class="pb-4">
                <p class="font-weight-600 mb-2">
                  Oops, no candidates found.
                </p>
                Try modifying search keywords and find relevant candidates.
              </div>
            </div>
          </div>

          <span *ngIf="isLoading" style="width: 100%; display: flex; justify-content: center; align-items: center;">
            <img style="width: 100px; margin: 0px 70px; height: 100px;" src="../../../assets/rolling-loader.gif" alt="">
          </span>

        </div>
      </div>
    </div>

  </div>
</div>


<ng-template #historymodal class="modal">
  <div class="modal-content">
    <div class="modal-body px-3 pb-6 pt-3">
      <div class="d-flex justify-content-between mb-3">
        <div>
          <span class="font-weight-600">
            Search History
          </span>

        </div>
        <span class="text-bluex pointer">
          <i class="far fa-times f-16" (click)="modalService.dismissAll()"> </i>
        </span>
      </div>
      <div class="scroll-widget" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
        [scrollWindow]="false" (scrolled)="gethistory('pagination')">
        <div *ngFor="let history of searchToolboxHistory; index as i" class="row mx-0 mb-3px">
          <div class="col bb-3px py-3" style="border-top: 1px solid rgba(0, 0, 0, 0.1);">
            <div class="row">
              <div class="col d-flex justify-content-between mb-0 px-0">
                <a data-testid="auto-searchtoolbox-v3-a-7" class="gray-text pointer collapsed font-weight-normal d-flex justify-content-between w-100"
                  data-bs-toggle="collapse" href="#collapseExample1{{i}}" role="button" aria-expanded="false"
                  aria-controls="collapseExample1" [ngClass]="{'showdhidearrow':!history.booleanquery}">
                  <div class="">
                    <p class="f-14 font-weight-500 text-black mb-0 text-capitalize">{{getHistoryHeadline(history)}}</p>
                  </div>
                  <div *ngIf="history.booleanquery">
                    <div class="col d-flex justify-content-between">
                      <p class="f-10 text-9696 mr-2 mt-1 mb-0" style="width: 105px;">{{formatDate(history?.updatedon)}}</p>
                      <i class="far fa-repeat-alt f-16 text-bluex" (click)="repeatSearch(history)"></i>
                    </div>
                  </div>
                  <div *ngIf="!history.booleanquery">
                    <div class="col d-flex justify-content-between">
                      <p class="f-10 text-9696 mr-2 mt-1 mb-0" style="width: 105px;">{{formatDate(history?.updatedon)}}</p>
                      <i class="far fa-repeat-alt f-16 text-bluex mr-2" (click)="repeatSearch(history)"></i>
                      <i class="far fa-chevron-down f-16 text-bluex"></i>
                      <i class="far fa-chevron-up f-16 text-bluex"></i>
                    </div>
                  </div>
                </a>
              </div>
            </div>

          </div>
          <div class="collapse px-3 w-100 mt-3px row mb-3" id="collapseExample1{{i}}" *ngIf="!history.booleanquery">
            <div class="row w-100">
              <div class="col-md-12" *ngIf="history?.booleanquery">
                <p class="mb-0">
                  {{history?.booleanquery}}
                </p>
              </div>
              <div class="col-md-6" *ngIf="history?.jobtitles">
                <p class="text-9696 mb-1"> Job Title </p>
                <p class="mb-0">
                  {{history?.jobtitles}}
                </p>
              </div>
              <div class="col-md-6" *ngIf="history?.mandatoryskills">
                <p class="text-9696 mb-1"> Mandatory Skills </p>
                <p class="mb-0">
                  {{history?.mandatoryskills}}
                </p>
              </div>
              <div class="col-md-6" *ngIf="history?.preferredskills">
                <p class="text-9696 mb-1"> Preferred Skills </p>
                <p class="mb-0">
                  {{history?.preferredskills}}
                </p>
              </div>
              <div class="col-md-6" *ngIf="history?.locations">
                <p class="text-9696 mb-1"> Location </p>
                <p class="mb-0">
                  {{history?.locations}}
                </p>
              </div>
            </div>
            <!-- <hr class="my-2"> -->
          </div>
        </div>
        <!-- <hr class="my-3"> -->
      </div>

    </div>
  </div>
</ng-template>



<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert error-message-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>


<ng-template #noCreditsJDParse class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-searchtoolbox-v3-button-7" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-6">
        <div class="col text-center mb-4">
          <img src="../../../assets/images/wallet.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col text-center ">
          <p class="font-weight-500 f-16 mb-2">Upgrade to keep going</p>
          <p class="">You have exhausted your limit for Search Using JD</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-searchtoolbox-v3-button-8" class="btn-trms-medium m-auto" (click)="route2pricing()">Upgrade plan</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #noCreditsGrab class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-searchtoolbox-v3-button-9" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-6">
        <div class="col text-center mb-4">
          <img src="../../../assets/images/wallet.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col text-center ">
          <p class="font-weight-500 f-16 mb-2">Upgrade to keep going</p>
          <p class="">You have exhausted your limit for Bulk Grabbing</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-searchtoolbox-v3-button-10" class="btn-trms-medium m-auto" (click)="route2pricing()">Upgrade plan</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #grabModal class="modal">

  <div class="modal-content">
    <div class="modal-header b pb-0 px-6 pt-4">
      <h5 class="modal-title f-16 font-weight-600" id="team">Bulk grabbing</h5>
      <button data-testid="auto-searchtoolbox-v3-button-11" type="button" class="close py-3 font-weight-normal" data-dismiss="modal" aria-label="Close"
        (click)="dismissBulkModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body px-3 pb-6 pt-2">
      <div class="gray-text col f-12 mb-2" style="line-height: 1.5;">
        This will grab the results in the background and directly add it to the talentpool that you select. We'll
        notify you by email once this is done. All the candidates that are found to be duplicates won't be grabbed.
      </div>
      <div class="col">
        <div class="f-12 font-weight-500 mb-2">
          <span *ngIf="candidatetoBeGrabbed?.length == 0">
            No of candidates
          </span>
          <span *ngIf="candidatetoBeGrabbed?.length > 0">
            Bulk candidates
          </span>
          <i class="fas fa-info-circle greybg ml-1" [ngbTooltip]="reserveCred" placement="right"
            tooltipClass="my-custom-class"></i>
          <ng-template #reserveCred>
            <span class="f-12"> These many candidates in the search result will be grabbed. All the candidates that
              already exist won’t be grabbed. </span>
          </ng-template>

          <input data-testid="auto-searchtoolbox-v3-input-8" type="text" placeholder="Enter no of candidates" class="wc-form-control nobg mt-1"
            [(ngModel)]="totalcandidatesForGrabString" style="pointer-events: none;border: none;
            padding-left: 0;
            font-weight: 500;" *ngIf="candidatetoBeGrabbed?.length > 0">

          <input data-testid="auto-searchtoolbox-v3-input-9" type="number" placeholder="Enter no of candidates" class="wc-form-control nobg mt-1"
            [(ngModel)]="totalcandidatesForGrab" *ngIf="candidatetoBeGrabbed?.length == 0">
        </div>
        <p class="text-danger f-12 mb-2"> {{ErrorMessage}}</p>

        <div class="f-12 font-weight-500 mb-4"> Select Talentpool
          <div class="position-relative">
            <div class="position-relative gray-text mt-3px">
              <input data-testid="auto-searchtoolbox-v3-input-10" (input)="getAllTalentpool()" type="text" placeholder="Select Talentpool"
                (click)="getAllTalentpool()" #trigger="matAutocompleteTrigger" (keyup.enter)="trigger.closePanel()"
                class="wc-form-control nobg" #talentpool [(ngModel)]="talentpoolname"
                [matAutocomplete]="talentpool_name">

              <mat-autocomplete #talentpool_name="matAutocomplete">
                <mat-option *ngFor="let talentpool of talentpoolslist" [value]="talentpool.name"
                  (onSelectionChange)="getAllTalentpool()">
                  {{talentpool.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <p *ngIf="noTalentpoolError" class="text-danger f-12">No Such Talentpool</p>
        </div>

        <div class="text-center">
          <button data-testid="auto-searchtoolbox-v3-button-12" class="btn-trms-small m-auto" (click)="doBulkExtraction()">OK</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #GrabInProgress class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-searchtoolbox-v3-button-13" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-6">
        <div class="col text-center mb-4">
          <img src="../../../assets/images/data-hosting-two-color.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col text-center ">
          <p class="font-weight-500 f-16 mb-2">Grabbing already in progress</p>
          <p class="">You already have a grabbing running in the background. Please try grabbing these candidates after
            that is done.</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-searchtoolbox-v3-button-14" class="btn-trms-small m-auto" (click)="modalService.dismissAll()">OK</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #GrabStarted class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-searchtoolbox-v3-button-15" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-6">
        <div class="col text-center mb-4">
          <img src="../../../assets/images/undraw-uploading-go-67.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col text-center ">
          <p class="font-weight-500 f-16 mb-2">Grabbing has started</p>
          <p class="">We'll grab the profiles in background and add it to the talentpool. We'll notify you via email
            once it's done

          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-searchtoolbox-v3-button-16" class="btn-trms-small m-auto" (click)="modalService.dismissAll()">OK</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noCreditsCE class="modal">
  <div class="modal-content">
      <div class="modal-body px-6 pb-6 pt-3">
          <div class="row mb-3">
              <div class="col pb-5">
                  <button data-testid="auto-searchtoolbox-v3-button-17" type="button" class="close position-absolute tr0" data-dismiss="modal"
                      aria-label="Close" (click)="modalService.dismissAll()">
                      <span aria-hidden="true">×</span>
                  </button>
              </div>
          </div>
          <div class="row mb-6">
              <div class="col text-center mb-4">
                  <img src="../../../assets/images/wallet.png" alt="img-fluid">
              </div>
          </div>
          <div class="row mb-3">
              <div class="col text-center ">
                  <p class="font-weight-500 f-16 mb-2">Upgrade to keep going</p>
                  <p class="" *ngIf="!isteamMember">You have exhausted your limit for contacts enmrichments</p>
                  <p class="" *ngIf="isteamMember">You have exhausted your limit to contacts enmrichments Request more credits from your team admin to keep
                    going</p>
              </div>
          </div>
          <div class="row" *ngIf="!isteamMember">
              <div class="col-md-10 mx-auto d-flex">
                  <!-- <button data-testid="auto-searchtoolbox-v3-button-18" class="col-md-4 mx-auto py-3 wc-ghostBtn" (click)="modaldismiss()">CANCEL</button> -->
                  <button data-testid="auto-searchtoolbox-v3-button-19" class="btn-trms-small m-auto" (click)="route2pricing()">Upgrade plan</button>
              </div>
          </div>
      </div>
  </div>
</ng-template>

<ng-template #requestCredit class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-searchtoolbox-v3-button-20" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-6">
        <div class="col text-center mb-4">
          <img src="../../../assets/images/wallet.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col text-center ">
          <p class="font-weight-500 f-16 mb-2">Request more credits</p>
          <p class="">You have exhausted your limit to send emails, Request more credits from your team admin to keep
            going</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #extractToTalentpool class="modal">
  <div class="modal-content">
    <div class="modal-header b pb-0">
      <h5 class="modal-title f-14 font-weight-500 mb-1">Add Candidate to Talentpool</h5>
      <button data-testid="auto-searchtoolbox-v3-button-21" type="button" class="py-3 font-weight-normal ms-auto no-outline-border-btn" data-dismiss="modal" aria-label="Close"
        (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <p class="text-9696 px-3 mb-0">If you wish to add this profile to a particular talent pool, kindly specify the talent pool below</p>
    <div class="modal-body">

      <app-add-to-talentpool style="display: block; margin: 0px -24px;" calledFrom="searchToolBox" [profileurlsarray]="profileurlsarray" (passEntry)="talentPoolandCandidateDataEvent($event)" [uiChange]="true"></app-add-to-talentpool>

      <div class=" float-right">
        <button data-testid="auto-searchtoolbox-v3-button-22" class="ms-auto" [disabled]="disablebutton" (click)="saveDataToTalentpool()" [ngClass] = "disablebutton ? 'disabled-button' : 'enabled-button'">
          <span [ngClass]="{ 'spinner-border text-light': addToTalentpoolSpinner }" [ngStyle] = "{ 'width: 20px; height: 20px;': addToTalentpoolSpinner }">
            {{addToTalentpoolSpinner ? '' : 'Save'}}
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #extractingProfile class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pt-3">
      <div class="row mb-3">
        <div class="col-md-10" style="line-height: 38px;">
          <p style="font-size: 14px;
          font-weight: 600;
          color: #484b59;"><i class="far fa-hourglass mr-1" style="color:#229300"></i> Extracting profiles to: <span style="text-transform: capitalize;">{{talentpoolAndCandidateData && modalDismissed == false ? talentpoolAndCandidateData.talentpoolname : 'All Candidates'}}</span> </p>
        </div>
      </div>
      <p style="margin-top: -30px;">Profiles are being extracted. Use advanced filters or <span> export to CSV the detailed work experience, years of experience, education history, skills and more.</span>
      </p>
      <p class="f-14"><i class="far fa-envelope mr-2"></i>You will be notified via email on completion.</p>

      <div style="
      display: flex;
      justify-content: flex-end;
  ">
      <button data-testid="auto-searchtoolbox-v3-button-23" class="enabled-button" style="width: 81px; height: 31px; margin-top: -8px;" (click)="modalService.dismissAll()">Okay</button>
      </div>
    </div>
  </div>
</ng-template>




<ng-template #premiumUserError class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col-md-12 pb-5">
          <p style=" font-family: Poppins;
          font-size: 14px;
          font-weight: 600;  color: #484b59;">Oops! Extraction feature is only for premium users</p>
        </div>
      </div>
      <div class="row mb-6">
        <div class="col text-center mb-4">
          <img src="../../../assets/images/premium-user-error.png" alt="img-fluid" style="width: 400px;
          height: 200px; ">
        </div>
      </div>

      <div style="color: #484b59;">
        <p style="font-weight: 600;">You are almost there..</p>
        <p style="font-weight: 500;">Upgrade to our premium service to be able to extract profile information seamlessly</p>
      </div>
      <div class="row">
        <div class="col-md-12 d-flex" style="justify-content: flex-end;">
          <button data-testid="auto-searchtoolbox-v3-button-24" class="btn-trms-white mr-2" (click)="modalService.dismissAll()">Do Not Extract</button>
          <button data-testid="auto-searchtoolbox-v3-button-25" class="btn-trms-medium" (click)="route2pricing()">Extract Profiles</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
